/** Presentation labels only; persisted role identifiers and permissions stay unchanged. */
export function applicationRoleLabel(role: string | null | undefined): string {
  return role === 'customer' ? 'Customer' : (role || '').replaceAll('_', ' ');
}
